export * from './slide-toggle.component';
